import { render, staticRenderFns } from "./DashboardRexItem.vue?vue&type=template&id=0ec382f1&"
import script from "./DashboardRexItem.vue?vue&type=script&lang=js&"
export * from "./DashboardRexItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports